import React from 'react';
import { closeModal, usePlayerUIContext } from '@24i/player-ui';
import { IconName } from '../../../Icons';
import { Button, StyledIcon } from './styled';
export const CloseButton = ({ type, styles, testID = 'close_button', }) => {
    const { dispatch } = usePlayerUIContext();
    return (React.createElement(Button, { testID: testID, onClick: () => {
            dispatch(closeModal(type));
        }, style: styles },
        React.createElement(StyledIcon, { name: IconName.close, color: "white" })));
};
//# sourceMappingURL=index.js.map